export default __webpack_public_path__ + "static/media/lineCapFlat.33fb26f8.svg";